import React, { useState } from "react"
import {formatDateTime, titleize} from '../../utils'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUndo } from '@fortawesome/pro-light-svg-icons/faUndo'
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons/faInfoCircle'

import LinkButton from "../LinkButton/LinkButton";
import ModalRoot from "../ModalRoot";
import Placeholder from "../Placeholder";
import ModalComponent from "../ModalComponent";
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import CustomGradeInputRow from "./CustomGradeInputRow"
import CollectionStatus from "./CollectionStatus"

import {currentCustomer, duckify, filterDuck} from "../../utils/duckify";
import { grades as gradesDuck, gradesSchoolYears as gradesSchoolYearsDuck, flashMessages, modals, schoolYears } from 'ducks'
import { compose } from "redux";
import { withRouter } from "react-router";
import { connect } from "react-redux";

const CustomGradeRow = ({ globalDatesStatus, grade, gradesSchoolYear, onDelete, onSubmit, schoolYear, customer }) => {
  const gradeSchoolYear = gradesSchoolYear.find(gsy => gsy.grade_id === grade.id)
  const isCustomGradeFound = !!gradeSchoolYear;
  const [isEditing, setIsEditing] = useState(false)
  const customGrade = {
    ...gradeSchoolYear,
    auto_open_date: gradeSchoolYear?.auto_open_date ? formatDateTime(gradeSchoolYear.auto_open_date, 'fns_date_time_minutes') : schoolYear.auto_open_date ? formatDateTime(schoolYear.auto_open_date, 'fns_date_time_minutes') : '',
    auto_close_date: gradeSchoolYear?.auto_close_date ? formatDateTime(gradeSchoolYear.auto_close_date, 'fns_date_time_minutes') : schoolYear.auto_close_date ? formatDateTime(schoolYear.auto_close_date, 'fns_date_time_minutes') : '',
    max_applicants: gradeSchoolYear?.max_applicants ? gradeSchoolYear.max_applicants : '',
    auto_collect: gradeSchoolYear ? gradeSchoolYear.auto_collect : schoolYear.auto_collect,
    grade_id: gradeSchoolYear?.grade_id ? gradeSchoolYear.grade_id : grade.id,
    school_year_id: gradeSchoolYear?.school_year_id ? gradesSchoolYear.school_year_id : schoolYear.id,
  }
  const status = gradeSchoolYear ?
    <CollectionStatus
      isCollected={gradeSchoolYear.is_collected}
      isWaitlisted={gradeSchoolYear.is_waitlisted}
      reasons={gradeSchoolYear.reasons}
    />
    : globalDatesStatus

  const appTerminology = customer && customer.admin_admissions_terms['noun'];

  return (
    <>
      <tr key={grade.id} data-group-id={grade.id} className={isCustomGradeFound ? 'selected' : 'not'}>
        <td>{grade ? grade.name : "An error has occurred"}</td>
        <td>{customGrade.auto_open_date}</td>
        <td>{customGrade.auto_close_date}</td>
        <td>
          <OverlayTrigger
            placement={'top'}
            overlay={
              <Tooltip>
                {titleize(appTerminology)}s collected:<span style={{marginLeft: '10px'}}>{customGrade.applicant_count}</span>
              </Tooltip>
            }
          >
            <span>
              {customGrade.max_applicants}
            </span>
          </OverlayTrigger>
        </td>
        <td>{customGrade.auto_collect ? `Collect and auto-waitlist ${appTerminology}s` : `Don't collect ${appTerminology}s`}</td>
        <td>{status}</td>
        <td className="grade-school-year-actions">
          {!isEditing ?
            <Button variant="outline-primary" size="sm" onClick={() => setIsEditing(true)}>Edit</Button> : ''}
          {isCustomGradeFound && !isEditing ?
            <LinkButton
              content={<FontAwesomeIcon icon={faUndo} className="hover-button red" />}
              onClick={() => onDelete(customGrade, grade.name)}
            /> : ''
          }
        </td>
      </tr>
      {isEditing &&
        <CustomGradeInputRow
          gradeSchoolYear={customGrade}
          onSubmit={onSubmit}
          setIsEditing={setIsEditing}
        />
      }
    </>
  )
}

const CustomGradeConfiguration = ({ allDucksReady, grades, gradesSchoolYear, onDelete, onSubmit, schoolYear, customer }) => {
  const globalDatesStatus = (
    <CollectionStatus
      isCollected={schoolYear.is_collected}
      isWaitlisted={schoolYear.is_waitlisted}
      reasons={schoolYear.reasons}
    />
  )

  const appTerminology = titleize(customer && customer.admin_admissions_terms['noun']);
  const applicantsTerminology = `${titleize(customer && customer.admin_admissions_terms['person'])}s`;

  return (
    <div className="custom-grade-configuration">
      <ModalRoot modals={{ ConfirmDelete }} />
      <fieldset>
        <legend className="custom-config-legend">
          Custom Grade Configuration
          <OverlayTrigger
            placement={'top'}
            overlay={
              <Tooltip id="custom-grade-config">
                Configure grade settings to establish open and close dates, and optionally impose a maximum applicant capacity.  Additionally, define the action to be triggered when the cap is attained.
              </Tooltip>
            }
          >
            <span>
              <FontAwesomeIcon className="tooltip-icon fa-sm" icon={faInfoCircle} />
            </span>
          </OverlayTrigger>
        </legend>
      </fieldset>

      <Placeholder.loading ready={allDucksReady}>
        <table className="table grades-school-years-list">
          <thead>
            <tr>
              <th>Grade</th>
              <th>Open Date</th>
              <th>Close Date</th>
              <th>Max {applicantsTerminology}</th>
              <th>Upon Close Date/Max {applicantsTerminology}</th>
              <th>{appTerminology} Collection Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {
              grades.map(grade => {
                return (<CustomGradeRow
                  key={grade.id}
                  globalDatesStatus={globalDatesStatus}
                  grade={grade}
                  gradesSchoolYear={gradesSchoolYear}
                  onDelete={onDelete}
                  onSubmit={onSubmit}
                  schoolYear={schoolYear}
                  customer={customer}
                />)
              })
            }
          </tbody>
        </table>
      </Placeholder.loading>
    </div>
  )
}

const ConfirmDelete = connect()(({ dispatch, gradesSchoolYear, gradeName, deleting = false }) => (
  <ModalComponent title="Confirm Delete"
    buttons={[
      <button className="btn btn-danger"
        disabled={deleting}
        onClick={() => {
          dispatch(modals.actions.update({ deleting: true }));
          dispatch(gradesSchoolYearsDuck.actions.remove(gradesSchoolYear))
            .then(() => dispatch(modals.actions.hide()))
            .then(() => dispatch(gradesSchoolYearsDuck.actions.markDirty()))
            .then(() => dispatch(schoolYears.actions.markDirty()))
            .then(() => dispatch(flashMessages.actions.show({
              type: 'success',
              message: `Custom grade configuration for ${gradeName} was successfully deleted.`,
              dismissible: true
            })))
            .catch(() => dispatch(modals.actions.show('UnexpectedError')));
        }}>{deleting ? 'Deleting...' : 'Delete'}</button>
    ]}
    closeText="Cancel">
    <p>Are you sure you want to delete the custom auto configuration for <em>{gradeName}</em>?</p>
  </ModalComponent>)
);

const mapDucksToProps = ({ schoolYear }) => {
  return ({
    grades: gradesDuck,
    gradesSchoolYear: filterDuck(gradesSchoolYearsDuck, { school_year_id: schoolYear.id }),
    customer: currentCustomer
  })
}

const mapDispatchToProps = (dispatch) => ({
  onDelete: (gradesSchoolYear, gradeName) => dispatch(modals.actions.show('ConfirmDelete', { gradesSchoolYear, gradeName })),
  onSubmit: (gradesSchoolYear, { setErrors }) => dispatch(gradesSchoolYearsDuck.actions.save(gradesSchoolYear))
    .then(() => dispatch(gradesSchoolYearsDuck.actions.markDirty()))
    .then(() => dispatch(schoolYears.actions.markDirty()))
    .catch(err => {
      const { response, ...cleanErrors } = err
      setErrors(cleanErrors)
    })
})

export default compose(
  withRouter,
  duckify(mapDucksToProps, () => ({}), mapDispatchToProps)
)(CustomGradeConfiguration)
